import { PRIVATE_HTTP as http } from "../http-common";

const notificationsAPI = async () => {
  return http().get(`/api/v4/users/notifications`);
};

export { notificationsAPI };
